import React from 'react';
import PropTypes from 'prop-types';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import styles from './styles/styles.module.scss';

const PageSwiper = ({ text, onClick }) => {
  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <div className={styles.text} onClick={onClick}>
          {text}
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <div className={styles.button} onClick={onClick}>
          <KeyboardArrowDownIcon />
        </div>
      </div>
    </div>
  );
};

PageSwiper.defaultProps = {
  text: 'Click Here',
  onClick: () => {}
};

PageSwiper.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func
};

export default PageSwiper;
